import { Delta } from 'quill'

export const getEditorLength = (delta: Delta, oldDelta: Delta): number => {
  const calculatedOldTextLengthList = oldDelta.ops?.map((op) => {
    if (op?.insert?.hashtag) {
      return op.insert.hashtag.length - 1
    }
    if (op?.insert) {
      return op.insert.trim().replace('\n', '').length
    }

    return 0
  })
  const oldTextLength = calculatedOldTextLengthList?.reduce(
    (acc, cur) => acc + cur,
    0,
  )
  const calculatedTextLengthList = delta.ops?.map((op) => {
    if (op?.insert?.hashtag) {
      return op.insert.hashtag.length - 1
    }
    if (op?.insert) {
      return op.insert.trim().replace('\n', '').length
    }
    if (op?.delete) {
      return op.delete * -1
    }

    return 0
  })
  const insertTextLength = calculatedTextLengthList?.reduce(
    (acc, cur) => acc + cur,
    0,
  )

  const textLength = oldTextLength + insertTextLength ?? 0

  return textLength
}
